import React, { useContext } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import MenuDetails from "../Components/MenuDetails";
import "./MenuCardPage.css";
import rupeesvg from "../Images/rupee.svg";
import { contextApi } from "../State/Context";

function MenuCardPage() {
  const { state, dispatch } = useContext(contextApi);
  let Cardvalue = state.cardObject;

  return (
    <div className="MenuCard">
      <Navbar />
      <div className="menu_card">
        <img src={Cardvalue.image} alt="" className="menu_card_img" />
        <div className="menu_card_details">
          <h1 className="menu_card_title">{Cardvalue.name}</h1>
          <div className="item_star">
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-regular fa-star"></i>
          </div>
          <div className="menu_card_price">
            <img src={rupeesvg} alt="" /> {Cardvalue.price}
          </div>
          <div className="menu_card_desc">
            <h3>Description</h3>
            <div className="menu_card_para">{Cardvalue.overview}</div>
          </div>
          <button
            className="menu_card_btn"
            onClick={() => {
              dispatch({ type: "ADD_CART_ITEM", payload: Cardvalue });
              alert("Item Added");
            }}
          >
            Add to Cart
          </button>
        </div>
      </div>
      <MenuDetails onlyProduct={true} />
      <Footer />
    </div>
  );
}

export default MenuCardPage;
